import { Navigate } from 'react-router-dom'

// Guards design routes; redirects to /login when there's no admin/designer token.
export default function AuthRoute({ children }) {
  const token = sessionStorage.getItem('adminToken')
  if (!token) return <Navigate to="/login" replace />
  return children
}
